export function getRandomNumber(max: number) {
  return Math.floor(Math.random() * (max + 1));
}
